import React from 'react';
import Select from 'react-select';

// styles
import {
  SearchImg,
  TeamSearchClearFilterDiv,
  TeamSearchClearFilterP,
  TeamSearchHeadDiv,
  TeamSearchHeadDivLeft,
  TeamSearchHeadDivRight,
  TeamSearchHeadPart1,
  TeamSearchHeadPart1DivHead,
  TeamSearchHeadPart2,
  TeamSearchHeadPart2Div,
  TeamSearchHeadPart2DivHead2,
} from '../styles';

// Assets
import search from 'Assets/images/search.png';

// Config
import { deviceTypeFilterOptions, gearSubscriptionStatusFilterOptions } from 'Config/gearAssetsConstant';

const SearchFilters = ({
  nameFilter,
  handleNameFilterChange,
  handleDeviceTypeFilterChange,
  deviceTypeFilter,
  handleSubStatusFilterChange,
  subStatusFilter,
}) => {
  const customRoleStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? 'white' : 'black',
      width: '100%',
      fontFamily: 'Inter',
    }),
    control: (provide, state) => ({
      ...provide,
      flex: 1,
      width: '100%',
      minWidth: 100,
      display: 'flex',
      border: '1px solid #D0D5DD',
      borderRadius: 8,
      height: 44,
      fontWeight: 400,
      color: '#667085',
      fontSize: 16,
      fontFamily: 'Inter',
    }),
    container: base => ({
      ...base,
      flex: 1,
    }),
  };

  const clearFilters = () => {
    handleNameFilterChange('');
    handleDeviceTypeFilterChange(deviceTypeFilterOptions[0]);
    handleSubStatusFilterChange(gearSubscriptionStatusFilterOptions[0]);
  };

  return (
    <TeamSearchHeadDiv>
      <TeamSearchHeadDivLeft>
        <TeamSearchHeadPart1>
          <TeamSearchHeadPart2Div>
            <p>Search Nickname</p>
            <TeamSearchHeadPart1DivHead>
              <SearchImg src={search} />
              <input
                id="TextSearch"
                type="text"
                placeholder="Search"
                value={nameFilter}
                onChange={(e) => handleNameFilterChange(e.target.value)}
              />
            </TeamSearchHeadPart1DivHead>
          </TeamSearchHeadPart2Div>
        </TeamSearchHeadPart1>
        <TeamSearchHeadPart2>
          <TeamSearchHeadPart2Div>
            <p>Device Type</p>
            <TeamSearchHeadPart2DivHead2>
              <Select
                value={deviceTypeFilter}
                onChange={handleDeviceTypeFilterChange}
                options={deviceTypeFilterOptions}
                placeholder="All"
                styles={customRoleStyles}
              />
            </TeamSearchHeadPart2DivHead2>
          </TeamSearchHeadPart2Div>
        </TeamSearchHeadPart2>
        <TeamSearchHeadPart2>
          <TeamSearchHeadPart2Div>
            <p>Subscription Status</p>
            <TeamSearchHeadPart2DivHead2>
              <Select
                value={subStatusFilter}
                onChange={handleSubStatusFilterChange}
                options={gearSubscriptionStatusFilterOptions}
                placeholder="All"
                styles={customRoleStyles}
              />
            </TeamSearchHeadPart2DivHead2>
          </TeamSearchHeadPart2Div>
        </TeamSearchHeadPart2>
      </TeamSearchHeadDivLeft>
      <TeamSearchHeadDivRight>
        <TeamSearchClearFilterDiv onClick={clearFilters}>
          <TeamSearchClearFilterP>Clear Filters</TeamSearchClearFilterP>
        </TeamSearchClearFilterDiv>
      </TeamSearchHeadDivRight>
    </TeamSearchHeadDiv>
  );
};

export default SearchFilters;
